import { BASE_URL } from './chat'

const jsonHeaders = {
  'Content-Type': 'application/json',
  Accept: 'application/json'
}

function getAdminApiKey() {
  return process.env.VUE_APP_ADMIN_API_KEY || ''
}

function getUplistingSyncKey() {
  return process.env.VUE_APP_UPLISTING_SYNC_KEY || ''
}

function getAdminHeaders() {
  const apiKey = getAdminApiKey()
  return apiKey
    ? {
        ...jsonHeaders,
        'x-api-key': apiKey
      }
    : jsonHeaders
}

function warnMissingEnv(name) {
  if (
    process.env.NODE_ENV !== 'production' &&
    process.env.NODE_ENV !== 'test'
  ) {
    // eslint-disable-next-line no-console
    console.warn(`Missing ${name}; configure it in .env.local.`)
  }
}

const mockConversations = [
  {
    session_id: 'session_1',
    guest_name: 'AI Sandbox',
    room_property: 'Aurum',
    room: 'Not Assigned',
    status: '',
    updated_at: '1m ago',
    unread: 1,
    last_message: 'Sure!'
  },
  {
    session_id: 'session_2',
    guest_name: 'Laura R.',
    email: 'potentialguest@yahoo.com',
    phone: 'Not provided',
    room_property: 'Aurum',
    room: 'Not Assigned',
    status: 'Active Inquiry',
    check_in: '2026-06-25',
    check_out: '2026-06-28',
    guests: '2 Adults, 2 Children',
    total_guest: 4,
    updated_at: '1s ago',
    unread: 1,
    last_message: 'Hi is here a parking...'
  },
  {
    session_id: 'session_3',
    guest_name: 'Isyar',
    room_property: 'Aurum',
    room: 'Not Assigned',
    status: 'Confirmed',
    check_in: '2026-07-14',
    check_out: '2026-07-18',
    updated_at: '1d ago',
    unread: 0,
    last_message: 'What time is the check...'
  },
  {
    session_id: 'session_4',
    guest_name: 'Miguel',
    room_property: 'Aurum',
    room: 'Not Assigned',
    status: 'Needs checkin',
    check_in: '2026-06-20',
    check_out: '2026-06-22',
    updated_at: '1d ago',
    unread: 0,
    last_message: 'What time is the check...'
  },
  {
    session_id: 'session_5',
    guest_name: 'Ichwan',
    room_property: 'Aurum',
    room: 'Not Assigned',
    status: 'Cancelled Booking Request',
    updated_at: '1d ago',
    unread: 0,
    last_message: 'What time is the check...'
  },
  {
    session_id: 'session_6',
    guest_name: 'Josh',
    room_property: 'Aurum',
    room: 'Not Assigned',
    status: 'Pending Booking Request',
    check_in: '2026-08-01',
    check_out: '2026-08-05',
    updated_at: '1d ago',
    unread: 0,
    last_message: 'What time is the check...'
  }
]

function formatDateLabel(value) {
  if (!value) {
    return '1d ago'
  }

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return value
  }

  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric'
  })
}

function formatStayDate(value) {
  if (!value) {
    return null
  }

  // Prefer calendar date strings (YYYY-MM-DD) so timezone shifts do not change the day.
  const dateOnly = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/)
  const date = dateOnly
    ? new Date(
        Number(dateOnly[1]),
        Number(dateOnly[2]) - 1,
        Number(dateOnly[3])
      )
    : new Date(value)

  if (Number.isNaN(date.getTime())) {
    return value
  }

  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  })
}

function normalizeConversation(conversation) {
  const latestMessage =
    conversation.last_message ||
    conversation.latest_user_message ||
    conversation.latest_assistant_message ||
    (conversation.messages && conversation.messages.length
      ? conversation.messages[conversation.messages.length - 1].content
      : '')
  const sessionLabel = conversation.session_id
    ? conversation.session_id.replace(':', ' ')
    : 'conversation'

  return {
    ...conversation,
    guest_name:
      conversation.guest_name ||
      (conversation.source === 'uplisting'
        ? `Uplisting ${sessionLabel}`
        : 'Guest conversation'),
    email: conversation.email || null,
    phone: conversation.phone || null,
    total_guest:
      conversation.total_guest == null || conversation.total_guest === ''
        ? null
        : conversation.total_guest,
    source: conversation.source || null,
    room_property: conversation.room_property || 'Aurum',
    room: conversation.room || 'Not Assigned',
    check_in: conversation.check_in || null,
    check_out: conversation.check_out || null,
    check_in_label: formatStayDate(conversation.check_in),
    check_out_label: formatStayDate(conversation.check_out),
    updated_at:
      conversation.updated_at ||
      formatDateLabel(
        conversation.last_message_at || conversation.first_message_at
      ),
    unread: conversation.unread || 0,
    last_message: latestMessage || 'No messages yet'
  }
}

const mockSession = {
  session_id: 'session_2',
  guest_name: 'Laura R.',
  email: 'potentialguest@yahoo.com',
  phone: 'Not provided',
  room_property: 'Aurum',
  room: 'Not Assigned',
  status: 'Active Inquiry',
  check_in: '2026-06-25',
  check_out: '2026-06-28',
  updated_at: '1s ago',
  first_message_at: 'June 30th at 2:34 PM',
  guests: '4',
  total_guest: 4,
  messages: [
    { role: 'assistant', content: 'Hi, how can I help?', message_id: 'a1' },
    {
      role: 'guest',
      content: 'Is there a parking spot on Aurum?',
      message_id: 'g1'
    },
    {
      role: 'assistant',
      content: 'Hello! Yes, there is one dedicated parking space.',
      message_id: 'a2'
    }
  ],
  feedback: [{ message_id: 'a1', rating: 5, comment: 'Helpful response' }],
  comments: [
    {
      message_id: 'a1',
      author: 'support',
      comment: 'Follow up with housekeeping availability.'
    }
  ]
}

async function safeFetch(url, options, fallbackData) {
  try {
    const response = await fetch(url, options)
    if (!response.ok) {
      return fallbackData
    }
    const data = await response.json()
    return data
  } catch (error) {
    // Re-throw abort errors so they can be handled properly
    if (error.name === 'AbortError') {
      throw error
    }
    return fallbackData
  }
}

function parseConversationsRequest(limitOrOptions = 50) {
  if (typeof limitOrOptions === 'object' && limitOrOptions !== null) {
    return {
      limit: limitOrOptions.limit ?? 50,
      page: limitOrOptions.page ?? 1,
      q: limitOrOptions.q ?? ''
    }
  }

  return {
    limit: limitOrOptions,
    page: 1,
    q: ''
  }
}

export async function getAdminConversations(limitOrOptions = 50) {
  const { limit, page, q } = parseConversationsRequest(limitOrOptions)
  const params = new URLSearchParams({
    limit: String(limit),
    page: String(page)
  })
  if (q) {
    params.set('q', q)
  }

  const url = `${BASE_URL}/admin/conversations?${params.toString()}`
  const fallback = {
    conversations: mockConversations,
    total: mockConversations.length,
    page,
    limit
  }
  if (!getAdminApiKey()) {
    warnMissingEnv('VUE_APP_ADMIN_API_KEY')
  }

  const data = await safeFetch(url, { headers: getAdminHeaders() }, fallback)
  const conversations = Array.isArray(data)
    ? data
    : data.conversations || mockConversations
  const normalized = conversations.map(normalizeConversation)

  return {
    conversations: normalized,
    total: Array.isArray(data)
      ? normalized.length
      : Number(data.total) || normalized.length,
    page: Array.isArray(data) ? page : Number(data.page) || page,
    limit: Array.isArray(data) ? limit : Number(data.limit) || limit
  }
}

export async function syncUplistingConversations() {
  const syncKey = getUplistingSyncKey()
  if (!syncKey) {
    warnMissingEnv('VUE_APP_UPLISTING_SYNC_KEY')
    throw new Error('Missing VUE_APP_UPLISTING_SYNC_KEY')
  }

  const response = await fetch(`${BASE_URL}/uplisting/sync-conversations`, {
    method: 'POST',
    headers: getAdminHeaders(),
    body: JSON.stringify({ key: syncKey })
  })

  if (!response.ok) {
    const error = await response.text()
    throw new Error(`Uplisting sync failed: ${response.status} ${error}`)
  }

  const text = await response.text()
  return text ? JSON.parse(text) : { ok: true }
}

export async function getAdminSession(sessionId, signal) {
  const url = `${BASE_URL}/admin/session/${sessionId}`
  if (!getAdminApiKey()) {
    warnMissingEnv('VUE_APP_ADMIN_API_KEY')
  }
  const fetchOptions = signal
    ? { headers: getAdminHeaders(), signal }
    : { headers: getAdminHeaders() }
  const data = await safeFetch(url, fetchOptions, mockSession)
  const session = data.session_id ? data : mockSession
  return {
    ...session,
    email: session.email || null,
    phone: session.phone || null,
    total_guest: session.total_guest == null ? null : session.total_guest,
    check_in_label: formatStayDate(session.check_in),
    check_out_label: formatStayDate(session.check_out)
  }
}

export async function postFeedback({ messageId, rating, comment }) {
  const url = `${BASE_URL}/feedback`
  const response = await fetch(url, {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({
      message_id: messageId,
      rating,
      comment
    })
  })

  if (!response.ok) {
    throw new Error(`Feedback request failed: ${response.status}`)
  }

  return response.json()
}

export async function postAdminComment(
  sessionId,
  { messageId, author, comment }
) {
  const url = `${BASE_URL}/admin/session/${sessionId}/comments`
  const response = await fetch(url, {
    method: 'POST',
    headers: getAdminHeaders(),
    body: JSON.stringify({
      message_id: messageId,
      author,
      comment
    })
  })

  if (!response.ok) {
    throw new Error(`Comment request failed: ${response.status}`)
  }

  return response.json()
}
